import { cva } from 'class-variance-authority';

export const tabsWrapperClasses = cva('p-0-5 flex');

export const buttonWrapperClasses = cva(['text-sm transition-colors'], {
  variants: {
    isActive: {
      true: 'bg-cloud-50 border border-[#E6E6E6]',
      false: 'text-[#737373]'
    }
  },
  defaultVariants: {
    isActive: false
  }
});

export const selectWrapperClasses = cva(
  'focus:ring-cloud-50 cursor-pointer rounded-full border border-[#E6E6E6] p-2 text-sm focus:ring-2'
);
